import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { GoodsReceiptSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { ProductCostBreakdownsContainer } from "@/screens/Products/components/Product/Costs"

const productCostsSearchSchema = z.object({
  field: z.nativeEnum(GoodsReceiptSortField).optional().default(GoodsReceiptSortField.CheckedInOn),
  order: z.nativeEnum(SortingOrder).optional().default(SortingOrder.Desc),
})

export const Route = createFileRoute("/app/product/$productId/edit/_layout/costs")({
  validateSearch: zodValidator(productCostsSearchSchema),
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.COST_MAINTENANCE]}>
      <ProductCostBreakdownsContainer />
    </PermissionContentWrapper>
  ),
})
